import { Card, CardBody, Col } from "reactstrap";
import { SolidBorderStyleTitle } from "../../../../../../Constants/Constants";
import { SolidBordersStyleSubTitle } from "../../../../../../Data/Forms&Table/Forms/FormControls";
import CommonCardHeader from "../../../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import CommonCardFooter from "../../../Common/CommonCardFooter";
import SolidBorderStyleForm from "./SolidBorderStyleForm";

const SolidBorderStyle = () => {
  return (
    <Col sm="12" xxl="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={SolidBorderStyleTitle} span={SolidBordersStyleSubTitle} />
        <CardBody className="megaoptions-border-space-sm">
          <SolidBorderStyleForm />
        </CardBody>
        <CommonCardFooter footerClass="text-end" color1="primary" color2="light" />
      </Card>
    </Col>
  );
};
export default SolidBorderStyle;
